import React, { useCallback } from 'react';

import IconButton from '@mui/material/IconButton';

import LinkOffOutlinedIcon from '@mui/icons-material/LinkOffOutlined';

interface DisconnectCellProps {
  id: string;
  onClick: (id: string) => void;
  disabled?: boolean;
}

const DisconnectCell: React.FC<DisconnectCellProps> = ({ id, onClick, disabled = false }) => {
  const handleClick = useCallback(() => {
    onClick(id);
  }, [onClick, id]);

  return (
    <IconButton aria-label="delete" color="error" onClick={handleClick} disabled={disabled}>
      <LinkOffOutlinedIcon />
    </IconButton>
  );
};

export default DisconnectCell;
